export default __webpack_public_path__ + "static/news2-7ca341a6981447a699abe714e638cba5.jpg";